<section mat-dialog-title>
  <span class="test-title">Edit doc link</span>
  <button mat-dialog-close>
    <i class="icon-close"></i>
  </button>
</section>
<mat-dialog-content>
  <mat-form-field
    class="input-with-clear-btn min-w-[300px] w-full"
    appearance="outline"
  >
    <input
      type="text"
      [(ngModel)]="inputValue"
      [value]="inputValue"
      #input
      matInput
      placeholder="Enter external link"
    />
    @if(input.value) {
      <button
        class="test-clear-button"
        (click)="clear()"
        aria-label="Clear"
        mat-icon-button
        matSuffix
      >
        <i class="icon-close text-ui-dark text-3xl"></i>
      </button>
    }
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >CANCEL</button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold"
    (click)="confirm()"
  >SAVE</button>
</mat-dialog-actions>
